import React, { useState, useEffect, Fragment } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { getCMSlist } from '../../actions/users';
import ReactHTMLParser from 'react-html-parser';

const MidNewList = () => {

  const navigate = useNavigate()
  const {name} = useParams();
  const [userdet, setUser] = useState();

  useEffect(() => {
    getCmsList();
  }, []);

  const getCmsList = async () => {
    var test = await getCMSlist({ userId: name });
    if (test.Success)
      setUser(test.userValue)
    else
      toastAlert("error", "Error on Server")
  }

  function editR(id) 
  {
      if(id!='') {
          window.location="/cmsedit/"+id;
      } 
  }

  const columns = [
 
    {
        key: "question",
        text: "Question",
        className: "question",
        align: "center",
        sortable: false,
        cell: (record) => (
          <p className='text-center exchange_table_values'>{record.question}</p>
        )
      },
      {
    
        key: "answer",
        text: "Answer",
        className: "answer",
        align: "center",
        sortable: false,
        cell: record =>
        <div className='text-center exchange_table_values'><p>{ReactHTMLParser(record.answer)}</p></div>
    
      },
      {
        key: "date",
        text: "Date",
        className: "Date",
        align: "center",
        sortable: false,
        cell: record =>
          <div className='text-center exchange_table_values'><p>{moment(record.date).format('MMMM,Do YYYY, hh:mm A')}</p></div>
      },
    
      {
        key: "action",
        text: "Action",
        className: "action",
        width: 100,
        align: "center",
        sortable: false,
        cell: record => {
    
          return (
            <div className='text-center exchange_table_values'>
              <button
                data-toggle="modal"
                data-target="#update-template-modal"
                className="btn btn-primary btn-sm"
                onClick={() => editR(record._id)}
    
                style={{ marginRight: '5px' }}>
                <i className="fa fa-edit mr-1"></i> Edit
              </button>
            </div>
          );
        }
      },
    ];

  const configData = {
    page_size: 5,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No user found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: <> Previous </>,
        next: <>Next</>,
        last: "Last",
      },
    },
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
    defaultSortAsc: true,
  };

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'CMS List'} />
            <div className='common_page_scroller mt-5 pe-2'>
            <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>

            <div className="common_page_scroller mt-3 pe-2">
              <div className="page_header">
                <h2>CMS List</h2>
              </div>
              <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                <ReactDatatable
                  config={configData}
                  records={userdet}
                  columns={columns}
                />
              </div>
            </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default MidNewList